import styled from 'styled-components';
import Button from 'components/Core/Button';

const RightMenuContainer = styled.div`
  align-items: center;
  display: flex;
  list-style: none;
  margin-left: auto;
  padding: 0;
  white-space: nowrap;

  button {
    margin-right: 0 !important;
  }

  @media (max-width: 1199px) {
    .menu-item--parent-link {
      font-size: var(--font-size-13);
      padding: 0 16px;
      width: max-content;
    }
  }
`;

const StyledButton = styled(Button)`
  box-shadow: none;
  font-size: var(--font-size-16);
  line-height: initial;
  margin: 0 0 0 16px;
  padding: 16px 45px;

  a.menu-item--parent-link {
    background: var(--critical-3);
    color: white !important;
    padding: 16px 45px;
    transition: background 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);
    white-space: nowrap;
    &:hover {
      background: var(--critical-4);
    }
  }

  @media (max-width: 1450px) {
    font-size: var(--font-size-13);
    line-height: var(--line-height-100);
    padding: 13px 29px !important;
    width: max-content;
  }

  @media (max-width: 680px) {
    padding: 13px 17px !important;
  }
`;

const EmailCaptureContainer = styled.div`
  .section-hero--notification {
    text-align: center;
  }

  @media (max-width: 680px) {
    bottom: 0px;
    display: ${(props) => !props.showHeaderForm && 'none'};
    left: 0px;
    position: fixed;
    width: 100%;
  }
`;
const EmailCapture = styled.div`
  display: flex;
  height: 80px;

  .header-email-capture {
    padding: 0px !important;
    .text-field-wrapper {
      margin-right: 15px;
      .text-field-input {
        box-shadow: none;
        font-size: var(--font-size-13) !important;
        height: 44px !important;
        padding: 21px 23px !important;
        width: 100%;
      }
      @media (max-width: 767px) {
        font-size: var(--font-size-16) !important;
        height: 44px !important;
      }
    }

    .slick-list {
      margin-top: 5px;
      .slick-track {
        width: 390px !important;
        @media (max-width: 575px) {
          width: 100% !important;
        }
        .slick-slide {
          width: 390px !important;
          @media (max-width: 575px) {
            width: 100% !important;
          }
        }
        .signup-form--submit-button {
          height: 44px;
          width: 100%;
          max-width: 178px;
        }
      }
    }
  }

  .data-layer-form {
    flex-direction: row !important;
  }

  @media (max-width: 1399px) {
    height: 81px;
    a {
      font-size: var(--font-size-13);
      line-height: 15px;
      margin-bottom: 3px;
      padding: 13px 29px;
    }
  }

  @media (max-width: 680px) {
    background-color: white;
    border-top: 1px solid var(--grey-4);
    display: flex;
    justify-content: center;
    padding: 3px 15px 0px;

    a {
      margin: 0 10px 0 10px;
      padding: 15px 29px;
    }

    .text-field-wrapper {
      .text-field-input {
        width: 100%;
      }
    }
  }
  .input-success-value {
    .text-field-helper {
      display: none !important;
    }
  }
`;

export { RightMenuContainer, StyledButton, EmailCapture, EmailCaptureContainer };
